import {AsyncResult} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {RecruiterCodeDto} from 'Users/api';
import recruiterCodeApi from 'Users/api/recruiterCodeApi';
import {changeRecruiterCodes, RecruiterCodeActionType, searchRecruiterCodes} from './../ducks/recruiterCode';

function* searchRecruiterCodesApi(action: ReturnType<typeof searchRecruiterCodes>) {
  const data: AsyncResult<RecruiterCodeDto[]> = yield call(
    recruiterCodeApi.searchRecruiterCodes,
    action.payload.recruiterCode
  );

  if (E.isRight(data)) {
    yield put(changeRecruiterCodes(data.right));
  } else {
    yield put(changeRecruiterCodes([]));
  }
}

function* searchRecruiterCodesSaga() {
  yield takeLatest(RecruiterCodeActionType.SEARCH_RECRUITER_CODES, searchRecruiterCodesApi);
}

export default function*() {
  yield all([searchRecruiterCodesSaga()]);
}
